import Modal from "react-bootstrap/Modal";
import AvailabilityUserNoteEditor from "../components/AvailabilityUserNoteEditor";

const AvailabilityUserNoteModal = ({ visible, close, user, onUpdated }) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="lg"
      aria-labelledby="availability-user-note-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="availability-user-note-modal">
          Availability Note for {user?.surname}, {user?.forename}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {visible && <AvailabilityUserNoteEditor user={user} onUpdated={onUpdated} />}
      </Modal.Body>
    </Modal>
  );
};

export default AvailabilityUserNoteModal;
